import AddEditProjectModal from "@/components/AddEditProjectModal";
import { ProjectCreateLayout } from "@/components/ProjectCreate/layout";
import { GitProvider } from "@/store/gitStatusSlice";
import { useNavigate, useParams, useSearchParams } from "react-router";

const AINewProjectPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const provider = searchParams.get("provider");

  return (
    <ProjectCreateLayout showProjectName={true} hideCreateProject={true}>
      <div className="flex flex-col flex-1 justify-center items-center w-full text-md overflow-auto relative max-w-screen-lg mx-8 gap-3">
        <AddEditProjectModal
          close={(project, canvas) => {
            if (!canvas?.id) {
              navigate(-1);
              return;
            }

            navigate(`/canvases/${canvas.id}/editor`);
          }}
          provider={(provider as GitProvider) || GitProvider.GITHUB}
        />
      </div>
    </ProjectCreateLayout>
  );
};

export default AINewProjectPage;
